"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14337%3A224))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRCreditCard = createSVGIcon(
  <path
    d="M2.75 9.625v8.538c0 .186.151.337.337.337h17.826a.337.337 0 0 0 .337-.337V9.625m-18.5 0V5.838c0-.187.151-.338.337-.338h17.826c.186 0 .337.151.337.338v3.787m-18.5 0h18.5M12 15h6"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRCreditCard",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
